export enum StatusLabelColor {
  Red = 'RED',
  Green = 'GREEN',
  Yellow = 'YELLOW',
  Scarlet = 'SCARLET',
  Blue = 'BLUE',
  Gray = 'GRAY',
  Black = 'BLACK',
}

export enum DriverViewBackgroundColor {
  White = 'WHITE',
  Black = 'BLACK',
}
